import styled from "styled-components";
import { Box } from "@mui/material";

export const LoaderContainer = styled(Box)`
  padding-top: 2.75rem;
  background-color: #f4f4f4;
  border: 1px solid #e6e6e6;
`;